import axios from "axios";
import { fetchCsrfToken } from "./CSRF_Service";

const api = axios.create({
  baseURL: process.env.REACT_APP_AUTH_BASE_URL,
  withCredentials: true,
  xsrfCookieName: "XSRF-TOKEN",
  xsrfHeaderName: "X-XSRF-TOKEN",
  headers: {
    "X-Client": "candidate",
  },
});
async function getCsrfToken() {
  return await fetchCsrfToken();
}

let csrfPromise = null;

api.interceptors.request.use(
  async (config) => {
    const method = config.method?.toUpperCase();

     if (["POST", "PUT", "PATCH", "DELETE"].includes(method)) {
        const token = await getCsrfToken();
        config.headers["X-XSRF-TOKEN"] = token;
      }

    return config;
  },
  (error) => Promise.reject(error)
);


export const login = (credentials) => {
   // Ensure CSRF token is fetched before login attempt
  return api.post("/candidate-auth/login", { credentials });
};

export const resendVerification = (email) => {
  return api.post("/candidate-auth/resend-verification", null, {
    params: { email },
  });
};

export const registerCandidate = (data) => {
  return api.post("/candidate-auth/register", data);
};

export const verifyOtp = (email, otp) => {
  return api.post("/candidate-auth/verify-otp", { email, otp });
};

export const resendOtp = (email) => {
  return api.post("/candidate-auth/resend-otp", email, {
    headers: {
      "Content-Type": "text/plain",
    },
  });
};

export const forgotPassword = (email) => {
  return api.get("/candidate-auth/forgot-password", {
    params: { email },
  });
};

export const resetPassword = (credentials, otp) => {
  return api.post("/candidate-auth/reset-password", {
    credentials,
    otp,
  });
};

export const verifyPasswordOtp = (email, otp) => {
  return api.get("/candidate-auth/password-otp-verify", {
    params: { email, otp },
  });
};

export const editMobileNumber = (newMobileNo, credentials) => {
  return api.post(`/candidate-auth/edit-mobile-no/${newMobileNo}`, {
    credentials,
  });
};

export const logout = async () => {
  const { clearCsrfToken } = await import("./CSRF_Service");
  const result = await api.post("/candidate-auth/logout", {});
  // ✅ Clear CSRF token after logout so next session fetches a fresh one
  clearCsrfToken();
  return result;
};

export const getCaptcha = () => {
  return api.get("/captcha/generate");
};

export const verifyCaptcha = (captchaId, captchaValue) => {
  return api.post("/captcha/verify", {
    captchaId,
    captchaValue,
  });
};

const authApi = {
  login,
  resendVerification,
  registerCandidate,
  verifyOtp,
  resendOtp,
  forgotPassword,
  resetPassword,
  verifyPasswordOtp,
  editMobileNumber,
  logout,
  getCaptcha,
  verifyCaptcha,
};

export default authApi;